import Model from "./Model";

export default class MaterialModel extends Model {
  id: number;
  boardId: number;
  boardSectionId: number;
  examGroupId: number;
  questionId: number;
  highlighted: boolean;

  static __typename: string = "Material";

  constructor(material: any, getters: any) {
    super(getters);
    this.id = material.id;
    this.highlighted = material.highlighted;
    this.boardSectionId = material.boardSectionByBoardSectionsId || material.boardSectionId;
    this.boardId = material.boardByBoardId || material.boardId;
    this.questionId = material.questionByQuestionId || material.questionId;
    this.examGroupId = material.examGroupByExamGroupId || material.examGroupId;
  }

  boardSection() {
    if (this.boardSectionId) {
      return this.getters.boardSectionById(this.boardSectionId);
    } else {
      return { id: null, title: "Outros" };
    }
  }

  board() {
    return this.getters.boardById(this.boardId);
  }

  examGroup() {
    return this.getters.examGroupById(this.examGroupId);
  }

  subject() {
    return this.getters.subjectById(this.questionId)
  }
}